var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('draggable',{model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}},_vm._l((_vm.model),function(item){return _c('meditationItem',{key:item.id,attrs:{"item":item}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }